import { CSSProperties } from 'react'

// The type scale moved to `src/styles/type-scale.ts` so the `src/antd`
// Typography seam can read it without reaching into `src/storybook` (it is
// also where `update-design` keeps it). Re-exported here, unchanged, so the
// ~430 call sites that import `TVariant` / `variants` / `TFontWeight` /
// `fontWeights` from this module keep working.
export type { TVariant, TFontWeight } from 'src/styles/type-scale'
export { variants, fontWeights } from 'src/styles/type-scale'

export type TLoadingSizes = 'small' | 'default' | 'large' | 'full'

export const loadingStylesMap: Record<TLoadingSizes, CSSProperties> = {
  small: { width: 120 },
  default: { width: 150 },
  large: { width: 250 },
  full: { width: '100%' },
}
